import React from 'react';
import Select from 'react-select';

type CompanySelectProps = {
  companyOfficeOptions: Array<{ value: string; label: string }>;
  maxWidth?: number | string;
  placeholder?: string;
  onChange: (option: { value: string }) => void;
  inputId?: string;
};

const CompanyOfficeSelect = ({
  companyOfficeOptions, maxWidth = 350, placeholder, onChange, inputId
}: CompanySelectProps) => {
  return (
    <Select
      inputId={inputId}
      options={companyOfficeOptions}
      placeholder={placeholder}
      styles={{
        control: base => ({
          ...base,
          maxWidth
        }),
        valueContainer: base => ({
          ...base
        }),
        input: base => ({
          ...base,
          margin: 0
        }),
        indicatorsContainer: base => ({
          ...base
        }),
        placeholder: base => ({
          ...base
        }),
      }}
      value={null}
      onChange={onChange}
    />
  );
};

export default CompanyOfficeSelect;
